var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67395 11.7454L11.0627 8.57562C11.5009 8.31785 11.5009 7.68414 11.0627 7.42637L5.67395 4.25654C5.22953 3.99511 4.66927 4.31555 4.66927 4.83116V11.1708C4.66927 11.6864 5.22953 12.0069 5.67395 11.7454ZM11.7387 9.72486C13.0533 8.95156 13.0533 7.05043 11.7387 6.27713L6.34998 3.10729C5.01671 2.32302 3.33594 3.28433 3.33594 4.83116V11.1708C3.33594 12.7177 5.01671 13.679 6.34998 12.8947L11.7387 9.72486Z",
    fill: "#272B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNew);
export default __webpack_public_path__ + "static/media/play_new.1436a7b23abb7a028b6b7bb69f62b001.svg";
export { ForwardRef as ReactComponent };